// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"317":"9b72ab83","599":"74c411cb"}[chunkId] + ".chunk.css";
};